import React, { useState } from 'react';
import { CourseList } from './components/CourseList';
import { ModuleList } from './components/ModuleList';
import { LessonTestPanel } from './components/LessonTestPanel';
import { BookOpen } from 'lucide-react';

const LessonsPage = () => {
  const [selectedCourseId, setSelectedCourseId] = useState<string>('');
  const [selectedModuleId, setSelectedModuleId] = useState<string>('');

  const handleSelectCourse = (courseId: string) => {
    setSelectedCourseId(courseId);
    setSelectedModuleId(''); // Reset module selection when course changes
  };

  const handleSelectModule = (moduleId: string) => {
    setSelectedModuleId(moduleId);
  };

  return (
    <div className="space-y-6 h-[calc(100vh-100px)] flex flex-col">
      <div className="shrink-0">
        <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Darslar (Lessons)</h1>
        <p className="text-sm text-slate-500 mt-1">
          Kursni tanlang, so'ng modulni, keyin darslar va testlarni boshqaring
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 flex-1 min-h-0 overflow-hidden pb-4">
        {/* Panel 1: Courses */}
        <div className="md:col-span-3 h-full overflow-hidden">
          <CourseList 
            selectedCourseId={selectedCourseId} 
            onSelectCourse={handleSelectCourse} 
          />
        </div>

        {/* Panel 2: Modules */}
        <div className="md:col-span-4 h-full overflow-hidden">
          {!selectedCourseId ? (
            <div className="h-full flex flex-col items-center justify-center text-center p-6 bg-slate-50/50 rounded-2xl border border-dashed border-slate-200">
              <BookOpen className="size-10 text-slate-300 mb-3" />
              <p className="text-sm font-medium text-slate-600">Kurs tanlanmagan</p>
              <p className="text-xs text-slate-500 mt-1">Chap tomondan kerakli kursni tanlang</p>
            </div>
          ) : (
            <ModuleList 
              courseId={selectedCourseId} 
              selectedModuleId={selectedModuleId} 
              onSelectModule={handleSelectModule} 
            />
          )}
        </div>

        {/* Panel 3: Lessons & Tests */}
        <div className="md:col-span-5 h-full overflow-hidden">
          {!selectedModuleId ? (
            <div className="h-full flex flex-col items-center justify-center text-center p-6 bg-slate-50/50 rounded-2xl border border-dashed border-slate-200">
              <BookOpen className="size-10 text-slate-300 mb-3" />
              <p className="text-sm font-medium text-slate-600">Modul tanlanmagan</p>
              <p className="text-xs text-slate-500 mt-1">O'rta panneldan darslarini ko'rish uchun modul tanlang</p>
            </div>
          ) : (
            <LessonTestPanel 
              courseId={selectedCourseId} 
              moduleId={selectedModuleId} 
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LessonsPage;
